import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getEmployeeFormBuilderHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.employeeFromList(action.payload),
		);
		yield put({
			type: types.GET_EMPLOYEEFORMLIST_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_EMPLOYEEFORMLIST_ERROR,
			payload,
		});
	}
}

export function* getEmployeeFormBuilderWatcherSaga() {
	yield takeLatest(
		types.GET_EMPLOYEEFORMLIST_START,
		getEmployeeFormBuilderHandlerSaga,
	);
}

//get/id

//create
